import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-807"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.555.154C9.513.145 9.47.142 9.426.134A7.983 7.983 0 0 0 8.795.04 8 8 0 1 0 8 16a7.955 7.955 0 0 0 .795-.04c.214-.021.423-.057.631-.094.043-.008.087-.011.13-.02a7.998 7.998 0 0 0 0-15.692zm.113 15.158A7.5 7.5 0 1 1 8 .5a7.44 7.44 0 0 1 1.668.189 8.497 8.497 0 0 0 0 14.623z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }